(function ($) {

    $.fn.listColor = function () {

        this.each((i, el) => {
            const $self = $(el);

            $self.find('ul').each(function() {
                    var color = $(this).find('ul li span').css('color');
                    $(this).find('ul li').css('color', color);            
            });
            
            $self.find('ol').each(function() {
                    var color = $(this).find('ol li span').css('color');
                    $(this).find('ol li').css('color', color);            
            });
        });
        return this;
    }

    $(() => {
        $('.page-row').listColor();
    });

})($);


// WEBPACK FOOTER //
// ./scripts/components/list-color.js